export default __webpack_public_path__ + "static/media/btn_more.f6fa0658.svg";